import { Component, Input, OnChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ApprovedHousingComplex, AcademicSession, CampusWardSessionInformation, HousingDataService, SortService } from '../../../shared';

@Component({
  selector: 'app-housing-complex-selection',
  templateUrl: './housing-complex-selection.component.html',
  styleUrls: ['./housing-complex-selection.component.scss']
})
export class HousingComplexSelectionComponent implements OnChanges {

  @Input() housingComplexes: ApprovedHousingComplex[] = null;
  @Input() academicSessions: AcademicSession[] = null;

  selectedHousingComplex: ApprovedHousingComplex = null;
  selectedAcademicSession: AcademicSession;
  findingHousingWards = false;
  housingWards: CampusWardSessionInformation[];
  hasHousingError = false;

  constructor(private housingService: HousingDataService, private sorter: SortService) { }

  ngOnChanges() {
    if (this.academicSessions && this.academicSessions.length > 0) {
      this.academicSessions.sort(this.sorter.sortAcademicSessionsAsc);
      this.selectedAcademicSession = this.academicSessions[0];
    }

    if (this.housingComplexes) {
      this.housingComplexes.sort(this.sorter.sortHousingComplexesAsc);
    }
  }

  /**
   * Gets the wards that are associated to the selected housing complex for the selected academic session.
   */
  getWardsForHousing(): void {
    if (this.selectedAcademicSession && this.selectedHousingComplex) {
      this.findingHousingWards = true;
      this.housingWards = null;
      this.hasHousingError = false;
      this.housingService.getCampusWardSessionInformation(this.selectedHousingComplex.complexId, this.selectedAcademicSession.sessionNumber)
      .pipe(
        finalize(() => this.findingHousingWards = false)
      )
      .subscribe(information => {
          this.housingWards = information;
          this.housingWards.sort(this.sorter.sortCampusWardSessionInformationsAsc);
        },
        error => {
          this.hasHousingError = true;
        });
    }
  }

}
